import type { AdminSystem } from '@fruuit/shared'
import { useApiQuery } from '../../api/hooks'

export const systemKey = ['admin', 'system'] as const

/** Non-secret deployment settings for the Docs page (platform admin). */
export function useAdminSystem() {
  return useApiQuery<AdminSystem>(systemKey, '/admin/system', { staleTime: 60_000 })
}
